import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes = [{
    path: '/',
    redirect: '/index',
}, {
    path: '/index',
    name: 'index',
    component: () => import('@views/shop/index.vue')
}, {
    path: '/des',
    name: 'des',
    component: () => import('@views/shop/des.vue')
}, {
    path: '/shoplist',
    name: 'shoplist',
    component: () => import('@views/shop/shoplist.vue')
}, {
    path: '/shopinfo',
    name: 'shopinfo',
    component: () => import('@views/shop/info.vue')
}, {
    path: '/infodes',
    name: 'infodes',
    component: () => import('@views/shop/infodes.vue')
}, {
    path: '/test',
    name: 'test',
    component: () => import('@views/test.vue')
}, {
    path: '/about',
    name: 'about',
    component: () => import('@views/about.vue')
}, {
    path: '/aboutMe',
    component: () => import('@views/aboutme.vue'),
}, {
    path: '/reg',
    name: 'reg',
    component: () => import('@views/login/reg.vue')
}, {
    path: '/my',
    component: () => import('@views/my/my.vue'),
    children: [{
        path: '/',
        component: () => import('@views/my/index.vue')
    }, {
        path: '/admin',
        name: 'admin',
        component: () => import('@views/my/mydt.vue')
    }, {
        path: '/ques',
        name: 'ques',
        component: () => import('@views/my/art_ques.vue')
    }, {
        path: '/add',
        name: 'add',
        component: () => import('@views/my/art_add.vue')
    }, {
        path: '/chong',
        name: 'chong',
        component: () => import('@views/my/chong.vue')
    }]
}, {
    path: '/user',
    component: () => import('@views/user.vue'),
    children: [{
        path: '/',
        // component: () => import('@views/my/art.vue')
        component: () => import('@views/my/mydt.vue')
    }]
}]
const router = new VueRouter({
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    },
    routes
})
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
    if (document.querySelector('main')) {
        document.querySelector('main').scrollTop = 0
    }
})

export default router